export const portfolioItems = [
  {
    id: 1,
    title: 'My Awesome Website',
    image: 'basquiat.png', // Replace with your image
    shortDescription: 'A personal website showcasing my skills and experience.',
    category: 'web',
    link: 'https://...', // Link to project
    description: '...', // Detailed project description
  },
  {
    id: 2,
    title: 'Coaching Tennis',
    image: 'tennis-coaching.jpg', // Replace with your image
    shortDescription: 'Develop a training program and techniques for effective tennis instruction.',
    category: 'coaching', // Add a new category for coaching
    link: 'https://...', // Link to project (optional)
    description: '...', // Detailed project description (optional)
  },
  {
    id: 3,
    title: 'Exploring Mental Health',
    image: 'mental-health.jpg', // Replace with your image
    shortDescription: 'Research and understanding of mental health concepts and practices.',
    category: 'education', // Use an existing category or create a new one
    link: 'https://...', // Link to project (optional)
    description: '...', // Detailed project description (optional)
  },
  {
    id: 4,
    title: 'Yoga and Fitness Journey',
    image: 'yoga-fitness.jpg', // Replace with your image
    shortDescription: 'Documenting my personal journey of combining yoga and fitness practices.',
    category: 'wellness', // Add a new category for wellness
    link: 'https://...', // Link to project (optional)
    description: '...', // Detailed project description (optional)
  },
  // Add more portfolio items with relevant properties
];
